import React, { useState, useRef, useEffect } from "react";
import { BsFillPersonFill } from "react-icons/bs";
import { RiGraduationCapFill } from "react-icons/ri";
import InputBox from "../FormElements/inputBox";
import SelectBox from "../FormElements/selectBox";
import ReCAPTCHA from "react-google-recaptcha";
import FooterComponent from "./footerComponent";
import HeaderComponent from "./headerComponent";
const API_SAVE_USERDATA = process.env.REACT_APP_API_URL + '?action=registration';
const API_COUNTRY_PATH = process.env.REACT_APP_API_URL + '?action=getCountries';
export default function OuterComponent() {
  const [selectedRole, setSelectedRole] = useState('parent');
  //parent
  const [parentfirstname, setParentFirstname] = useState('');
  const [parentlastname, setParentLastname] = useState('');
  const [parentemail, setParentEmail] = useState('');
  const [parentstudentyear, setParentStudentYear] = useState('2023');
  const [parentstudentfirstname, setParentStudentFirstname] = useState('');
  const [parentstudentlastname, setParentStudentLastname] = useState('');
  const [parentstudentemail, setParentStudentEmail] = useState('');
  const [parentstate, setParentState] = useState('');
  const [parentcountry, setParentCountry] = useState('');
  const [isus, setIsUs] = useState('1');

  //student
  const [studentfirstname, setStudentFirstname] = useState('');
  const [studentlastname, setStudentLastname] = useState('');
  const [studentemail, setStudentEmail] = useState('');
  const [studentparentyear, setStudentParentYear] = useState('2023');
  const [studentparentfirstname, setStudentParentFirstname] = useState('');
  const [studentparentlastname, setStudentParentLastname] = useState('');
  const [studentparentemail, setStudentParentEmail] = useState('');
  const [studentstate, setStudentState] = useState('');
  const [studentcountry, setStudentCountry] = useState('');
  const [isshowstate, setIsShowState] = useState(true);
  const [errorMsg, setErrorMsg] = useState(false);
  const [stateoptions, setSateOptions] = useState([
    { value: '', label: 'Select' }
  ]);
  const [countryoptions] = useState([
    { value: '', label: 'Select' }
  ]);
  const [yearoptions] = useState([
    { value: "2023", label: "2023" },
    { value: "2024", label: "2024" },
    { value: "2025", label: "2025" },
    { value: "2026", label: "2026" },
    { value: "2027", label: "2027" },
    { value: "2028", label: "2028" },
    { value: "2029", label: "2029" },
    { value: "2030", label: "2030" },
    { value: "2031", label: "2031" },
    { value: "2032", label: "2032" }
  ]);
  useEffect(() => {
    // function for setting progressbar
    getCountries();

  }, []);
   //api for getting countries
   async function getCountries() {
    fetch(API_COUNTRY_PATH, {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      },
    })
      .then(response => response.json())
      .then(response => {
        response.COUNTRY.map(x => {
          let option = { label: x.VALUE, value: x.KEY };
          countryoptions.push(option);
        })
        let opt = [{ value:'', label: 'Select' }];
        response.STATES.map(y => {
          let options = { label: y.VALUE, value: y.KEY };
          opt.push(options);
        })
        setSateOptions(opt)
      })
      .catch(err => {
        console.log(err);
      });
  }
  const handleRoleChange = (role) => {
    setSelectedRole(role);
    resetAllFields();
  };

  // reset all fileds
  async function resetAllFields() {

    // parent
    setParentFirstname('');
    setParentLastname('');
    setParentEmail('');
    setParentStudentYear('2023');
    setParentStudentFirstname('');
    setParentStudentLastname('');
    setParentStudentEmail('');
    setParentEmail('');
    setParentState('');
    setParentCountry('');

    // student
    setStudentFirstname('');
    setStudentLastname('');
    setStudentEmail('');
    setStudentState('');
    setStudentCountry('');
    setStudentParentYear('2023');
    setStudentParentFirstname('');
    setStudentParentLastname('');
    setStudentParentEmail('');
    setStudentCountry('');
  }

  // change residence
  function changeResidence(residence) {
    if (residence === '1') {
      setIsShowState(true);
    } else {
      setIsShowState(false);
    }
  }
  const reCaptchaRef = useRef();

  const validateFields = () => {
    let isValid = true;

    if (selectedRole === "parent") {
      if (!parentfirstname || !parentlastname || !parentemail || !parentstudentfirstname) {
        setErrorMsg("Please fill in all required fields.");
        isValid = false;
      } else {
        setErrorMsg("");
      }
    } else {
      if (
        !studentfirstname ||
        !studentlastname ||
        !studentemail ||
        !studentparentfirstname ||
        !studentparentlastname ||
        !studentparentemail
      ) {
        setErrorMsg("Please fill in all required fields.");
        isValid = false;
      } else {
        setErrorMsg("");
      }
    }

    return isValid;
  };


  const handleSubmit = async () => {

    const isValid = validateFields();

    if (isValid) {
      // You can access the reCAPTCHA token using reCaptchaRef
      const token = await reCaptchaRef.current.executeAsync();
      reCaptchaRef.current.reset();

      const formData = {};

      if (selectedRole === 'parent') {
        formData.parentfirstname = parentfirstname;
        formData.parentlastname = parentlastname;
        formData.parentemail = parentemail;
        formData.parentstudentyear = parentstudentyear;
        formData.parentstudentfirstname = parentstudentfirstname;
        formData.parentstudentlastname = parentstudentlastname;
        formData.parentstudentemail = parentstudentemail;
        formData.parentstate = parentstate;
        formData.parentcountry = parentcountry;
      } else {
        formData.studentfirstname = studentfirstname;
        formData.studentlastname = studentlastname;
        formData.studentemail = studentemail;
        formData.studentparentyear = studentparentyear;
        formData.studentparentfirstname = studentparentfirstname;
        formData.studentparentlastname = studentparentlastname;
        formData.studentparentemail = studentparentemail;
        formData.studentstate = studentstate;
        formData.studentcountry = studentcountry;
      }

      // Log the form data and reCAPTCHA token (you can replace this with your submission logic)
      saveUserDetails(formData);
      console.log('Form Data:', formData);
      console.log('reCAPTCHA Token:', token);

      //window.location = 'survey';
    } else {
      console.log('Fieldes are empty');
    }
  };

  // save demographics
  async function saveUserDetails(formData) {
    //are you a parent or student
    let usertype = '';

    //us parent or student
    let sectionname = '';

    //is parent
    let isparent = '';
    let isusentity = '';

    //initialize parent  fields
    let parentfirstname_loc = '';
    let parentlastname_loc = '';
    let parentemail_loc = ''
    let parentstate_loc = ''
    let parentcountry_loc = ''

    //initialize student fields
    let studentfirstname_loc = '';
    let studentyear_loc = '';
    let studentlastname_loc = '';
    let studentemail_loc = '';
    let studentstate_loc = '';
    let studentcountry_loc = '';

    if (selectedRole === 'parent') {
      isparent = 1;
      //parent
      usertype = 2;
      if (isus === '1') {
        sectionname = "us_parent";
        isusentity = 1;
        parentcountry_loc = '';
        parentstate_loc = formData.parentstate;

      } else {
        isusentity = 0;
        sectionname = "non_us_parent"
        parentstate_loc = '';
        parentcountry_loc = formData.parentcountry;

      }

      //parent data
      parentfirstname_loc = formData.parentfirstname;
      parentlastname_loc = formData.parentlastname;
      parentemail_loc = formData.parentemail;

      //student data
      studentfirstname_loc = formData.parentstudentfirstname;
      studentyear_loc = formData.parentstudentyear;
      studentlastname_loc = '';
      studentemail_loc = '';
      studentstate_loc = '';
      studentcountry_loc = '';

    } else {
      isparent = 0;

      //student
      usertype = 1;
      if (isus === '1') {
        sectionname = "us_student";
        isusentity = 1;
        studentstate_loc = formData.studentstate;
        studentcountry_loc = '';
      } else {
        sectionname = "non_us_student"
        isusentity = 0;
        studentstate_loc = '';
        studentcountry_loc = formData.studentcountry;
      }

      //student data
      studentfirstname_loc = formData.studentfirstname;
      studentyear_loc = formData.studentparentyear;
      studentlastname_loc = formData.studentlastname;
      studentemail_loc = formData.studentemail;

      //parent data
      parentfirstname_loc = formData.studentparentfirstname;
      parentlastname_loc = formData.studentparentlastname;;
      parentemail_loc = formData.studentparentemail;
      parentstate_loc = '';
      parentcountry_loc = '';
    }
    fetch(API_SAVE_USERDATA, {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        sectionname: sectionname,
        usertype: usertype,
        isparent: isparent,
        isusentity: isusentity,
        parentfirstname:parentfirstname_loc,
        parentlastname:parentlastname_loc,
        parentemail:parentemail_loc,
        parentstate:parentstate_loc,
        parentcountry:parentcountry_loc,
        studentfirstname:studentfirstname_loc,
        studentlastname:studentlastname_loc,
        graduationyear:studentyear_loc,
        studentemail:studentemail_loc,
        studentstate:studentstate_loc,
        studentcountry:studentcountry_loc
      })
    })
      .then(response => response.json())
      .then(response => {

        if (response.statuscode === 401) {
          
          alert(response.message);
        }
        else if (response.statuscode === 200) {
          let url = 'survey/' + response.data.survey_studentid + '/' + response.data.ssid;
          if (response.data.ssid !== '') {
            window.location = url;
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
  }
  return (
    <div className="page-wrapper bg-blue font-robo wrapper-container">
      <div>
        <div className="logo-wrapper padding-wrapper">
          <HeaderComponent />
          <div className="card card-wrapper">
            <div className="card-body">
              <h2 className="main-head">Hello,</h2>
              <p>Please tell as about yourself so we can better assist you with your college search</p>
              <h3>Are you a,</h3>
              <div className="toggle-switch-container">
                <button
                  className={`toggle-left toggle-button ${selectedRole === 'parent' ? 'active' : ''}`}
                  onClick={() => handleRoleChange('parent')}
                >
                  <BsFillPersonFill /> Parent
                </button>
                <button
                  className={`toggle-right toggle-button ${selectedRole === 'student' ? 'active' : ''}`}
                  onClick={() => handleRoleChange('student')}
                >
                  <RiGraduationCapFill />  Student
                </button>
              </div>
              <div className="form-wrapper">
                <div className="outer-select">
                  <label className="label-dropdown">Country of Residence</label>
                  <select className="country-dropdown" onChange={(e) => { changeResidence(e.target.value); setIsUs(e.target.value) }}>
                    <option value="1">United States</option>
                    <option value="2">International</option>
                  </select>
                </div>
                <div className="line-break"></div>
                {errorMsg && <p className="error-message">{errorMsg}</p>}
                {selectedRole === 'parent' ? (
                  <div className="input-wrapper row">
                    {/* parent section */}
                    <InputBox
                      type="text"
                      label="First name"
                      name="parentfirstname"
                      setstate="setParentFirstname"
                      value={parentfirstname}
                      onChange={(newValue) => setParentFirstname(newValue)}
                      isRequired
                    />
                    <InputBox
                      type="text"
                      label="Last name"
                      name="parentlastname"
                      value={parentlastname}
                      onChange={(newValue) => setParentLastname(newValue)}
                      isRequired
                    />
                    <InputBox
                      type="email"
                      label="Email"
                      name="parentemail"
                      value={parentemail}
                      onChange={(newValue) => setParentEmail(newValue)}
                      isRequired
                    />
                    <SelectBox
                      options={yearoptions}
                      label="Year of high school graduation"
                      name="parentstudentyear"
                      value={parentstudentyear}
                      onChange={(newValue) => setParentStudentYear(newValue)}
                    />
                    <InputBox
                      type="text"
                      label="Student first name"
                      name="parentstudentfirstname"
                      value={parentstudentfirstname}
                      onChange={(newValue) => setParentStudentFirstname(newValue)}
                      isRequired
                    />
                    <InputBox
                      type="text"
                      label="Student last name"
                      name="parentstudentlastname"
                      value={parentstudentlastname}
                      onChange={(newValue) => setParentStudentLastname(newValue)}
                    />
                    <InputBox
                      type="email"
                      label="Student email"
                      name="parentstudentemail"
                      value={parentstudentemail}
                      onChange={(newValue) => setParentStudentEmail(newValue)}
                    />
                    {isshowstate ? (
                      <SelectBox
                        options={stateoptions}
                        label="Home state"
                        name="parentstate"
                        value={parentstate}
                        onChange={(newValue) => setParentState(newValue)}
                      />
                    ) : (
                      <SelectBox
                        options={countryoptions}
                        label="Home country"
                        name="parentcountry"
                        value={parentcountry}
                        onChange={(newValue) => setParentCountry(newValue)}
                      />
                    )}
                  </div>
                ) : (
                  <div className="input-wrapper row">
                    {/* student section */}
                    <InputBox
                      type="text"
                      label="First name"
                      name="studentfirstname"
                      value={studentfirstname}
                      onChange={(newValue) => setStudentFirstname(newValue)}
                      isRequired
                    />
                    <InputBox
                      type="text"
                      label="Last name"
                      name="studentlastname"
                      value={studentlastname}
                      onChange={(newValue) => setStudentLastname(newValue)}
                      isRequired
                    />
                    <InputBox
                      type="email"
                      label="Email"
                      name="studentemail"
                      value={studentemail}
                      onChange={(newValue) => setStudentEmail(newValue)}
                      isRequired
                    />
                    <SelectBox
                      options={yearoptions}
                      label="Year of high school graduation"
                      name="studentparentyear"
                      value={studentparentyear}
                      onChange={(newValue) => setStudentParentYear(newValue)}
                    />
                    <InputBox
                      type="text"
                      label="Parent first name"
                      name="studentparentfirstname"
                      value={studentparentfirstname}
                      onChange={(newValue) => setStudentParentFirstname(newValue)}
                      isRequired
                    />
                    <InputBox
                      type="text"
                      label="Parent last name"
                      name="studentparentlastname"
                      value={studentparentlastname}
                      onChange={(newValue) => setStudentParentLastname(newValue)}
                      isRequired
                    />
                    <InputBox
                      type="email"
                      label="Parent email"
                      name="studentparentemail"
                      value={studentparentemail}
                      onChange={(newValue) => setStudentParentEmail(newValue)}
                      isRequired
                    />
                    {isshowstate ? (
                      <SelectBox
                        options={stateoptions}
                        label="Home state"
                        name="studentstate"
                        value={studentstate}
                        onChange={(newValue) => setStudentState(newValue)}

                      />
                    ) : (
                      <SelectBox
                        options={countryoptions}
                        label="Home country"
                        name="studentcountry"
                        value={studentcountry}
                        onChange={(newValue) => setStudentCountry(newValue)}
                      />
                    )}
                  </div>
                )}
                <div style={{ textAlign: 'center', marginLeft: 10 }}>
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_CATCHA_SITEKEY}
                    size="invisible"
                    ref={reCaptchaRef}
                  />
                  <button
                    type="submit"
                    value="Submit"
                    className="action-button"
                    onClick={handleSubmit}>
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <FooterComponent />
        </div>
      </div>
    </div>
  );
}
